import { LegalShell, LegalTitle, LegalUpdated, LegalH2, LegalDivider } from './shell';

/** Public Terms of Service — bilingual (EN + BG), paired with the Privacy Policy
 *  for Google OAuth verification. Public route, outside ProtectedRoute. */
export default function TermsPage() {
  return (
    <LegalShell>
      {/* ---------------------------------------------------------------- EN */}
      <LegalTitle>Terms of Service — Balance clinic ai agent</LegalTitle>
      <LegalUpdated>Last updated: 11 August 2026</LegalUpdated>
      <p>
        These Terms govern your use of Balance clinic ai agent (the “Service”), operated by Диадроу ЕООД
        (Diadraw Ltd.). By using the Service you agree to these Terms.
      </p>

      <LegalH2>1. The Service</LegalH2>
      <p>
        Balance clinic ai agent provides appointment scheduling and an AI assistant for clinics and their
        specialists, including optional integration with Google Calendar.
      </p>

      <LegalH2>2. Accounts</LegalH2>
      <p>
        The Service is intended for authorised clinic staff. Keep your credentials secure; you are
        responsible for activity that occurs under your account.
      </p>

      <LegalH2>3. Acceptable use</LegalH2>
      <p>
        Do not misuse the Service, attempt to gain unauthorised access, disrupt its operation, or use
        it for any unlawful purpose.
      </p>

      <LegalH2>4. Google integration</LegalH2>
      <p>
        Connecting Google Calendar is optional and is also governed by Google’s terms. You may
        disconnect at any time from within the app. Our handling of Google data is described in our
        Privacy Policy.
      </p>

      <LegalH2>5. No medical advice</LegalH2>
      <p>
        The Service supports scheduling and administration only. It does not provide medical advice,
        diagnosis or treatment.
      </p>

      <LegalH2>6. Availability and disclaimers</LegalH2>
      <p>
        The Service is provided “as is” and “as available”, without warranties of any kind to the
        extent permitted by law.
      </p>

      <LegalH2>7. Limitation of liability</LegalH2>
      <p>
        To the extent permitted by law, Диадроу ЕООД is not liable for indirect, incidental or
        consequential damages arising from use of the Service.
      </p>

      <LegalH2>8. Changes</LegalH2>
      <p>We may update these Terms; continued use of the Service means you accept the updated Terms.</p>

      <LegalH2>9. Governing law &amp; contact</LegalH2>
      <p>
        These Terms are governed by the laws of the Republic of Bulgaria. Contact:{' '}
        <a className="text-primary hover:underline" href="mailto:info@diadraw.com">info@diadraw.com</a>.
      </p>

      {/* ---------------------------------------------------------------- BG */}
      <LegalDivider label="Български" />
      <LegalTitle>Общи условия — Balance clinic ai agent</LegalTitle>
      <LegalUpdated>Последна актуализация: 11 август 2026 г.</LegalUpdated>
      <p>
        Тези Общи условия уреждат използването на Balance clinic ai agent („Услугата“), управлявана от Диадроу
        ЕООД. С използването на Услугата се съгласявате с тези условия.
      </p>

      <LegalH2>1. Услугата</LegalH2>
      <p>
        Balance clinic ai agent предоставя записване на часове и AI асистент за клиники и техните специалисти,
        включително по избор интеграция с Google Calendar.
      </p>

      <LegalH2>2. Профили</LegalH2>
      <p>
        Услугата е предназначена за оторизиран персонал на клиниката. Пазете данните си за достъп; вие
        отговаряте за действията, извършени през вашия профил.
      </p>

      <LegalH2>3. Допустимо ползване</LegalH2>
      <p>
        Не злоупотребявайте с Услугата, не се опитвайте да получите неоторизиран достъп, не нарушавайте
        работата ѝ и не я използвайте за незаконни цели.
      </p>

      <LegalH2>4. Интеграция с Google</LegalH2>
      <p>
        Свързването на Google Calendar е по избор и се урежда и от условията на Google. Може да
        прекъснете връзката по всяко време от приложението. Обработката на Google данните е описана в
        Политиката за поверителност.
      </p>

      <LegalH2>5. Без медицински съвет</LegalH2>
      <p>
        Услугата подпомага само записването и администрацията. Тя не предоставя медицински съвет,
        диагноза или лечение.
      </p>

      <LegalH2>6. Достъпност и отказ от гаранции</LegalH2>
      <p>
        Услугата се предоставя „както е“ и „както е достъпна“, без каквито и да е гаранции, доколкото
        законът позволява.
      </p>

      <LegalH2>7. Ограничаване на отговорността</LegalH2>
      <p>
        Доколкото законът позволява, Диадроу ЕООД не носи отговорност за непреки, случайни или
        последващи вреди, произтичащи от използването на Услугата.
      </p>

      <LegalH2>8. Промени</LegalH2>
      <p>Може да актуализираме тези условия; продължаването на ползването означава приемане на промените.</p>

      <LegalH2>9. Приложимо право и контакт</LegalH2>
      <p>
        Тези условия се уреждат от законите на Република България. Контакт:{' '}
        <a className="text-primary hover:underline" href="mailto:info@diadraw.com">info@diadraw.com</a>.
      </p>
    </LegalShell>
  );
}
